import apiConfig from "./ApiURL.json";
var apiEndpoint = process.env.VUE_APP_TOKO_API || apiConfig.invoice;
import App from "./App/App.js";

export default {
  getList(params) {
    let options = {
      cid: App.Session.getCompanyID(),
      uid: App.Session.getUserID()
    };
    options = Object.assign(options, params);
    const attributes = ["cid", "uid", "search", "warehouse", "field",
      "startdate", "enddate"];
    const urlParams = App.Out.getParams(options, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/api/v1/stockreduction/list" + urlParams
    };
  },
  getListData() {
    let options = {
      cid: App.Session.getCompanyID(),
      uid: App.Session.getUserID()
    };
    const attributes = ["cid", "uid"];
    const urlParams = App.Out.getParams(options, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/api/v1/stockreduction/listdata" + urlParams
    };
  },
  getNewData() {
    let options = { cid: App.Session.getCompanyID(), uid: App.Session.getUserID() };
    const attributes = ["cid", "uid"];
    const urlParams = App.Out.getParams(options, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/api/v1/stockreduction/newdata" + urlParams
    };
  },
  getDetailsData(id, params) {
    let options = {
      cid: App.Session.getCompanyID(),
      id: id,
      uid: App.Session.getUserID()
    };
    options = Object.assign(options, params);
    const attributes = ["cid", "id", "uid", "withcompany"];
    const urlParams = App.Out.getParams(options, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/api/v1/stockreduction/detailsdata" + urlParams
    };
  },
  postStockReduction(data) {
    return {
      method: App.Enum.Axios.Method.Post,
      url: apiEndpoint + "/api/v1/stockreduction",
      data: data
    };
  }
}